import { logErrorOnCrash } from './utils';

export function restartWebOnError(error, source = null) {
  logErrorOnCrash(error, source);
  window.location.replace(window.location.origin);
}

export function test() {}
